































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

const sha1 = require('crypto-js/sha1');

// const bcrypt = require('bcrypt');

@Component
export default class Home extends Vue {
  login: string = '';

  password: string = '';

  isWrongCredentials: boolean = false;

  get compWrongCredentials(): string {
    return this.isWrongCredentials ? 'login-form-wrong-credentials' : '';
  }

  get compConnectedButton(): boolean {
    return this.login === '' || this.password === '';
  }

  async digestPassword(password: string): Promise<any> {
    return sha1(password).toString();
  }

  async checkCredentials(): Promise<any> {
    const password = await this.digestPassword(this.password);
    await this.$store
      .dispatch('login/a_post_login', { login: this.login, password })
      .then(() => {
        this.$router.push('/dashboard');
      })
      .catch((err) => {
        if (err.response.status === 403) {
          this.$router.push('/changePassword');
        } else {
          console.log('Wrong credentials');
          this.isWrongCredentials = true;
        }
      });
  }

  onInputFocus(): void {
    this.isWrongCredentials = false;
  }
}
